module.exports = __webpack_public_path__ + "img/chenweier2.e000804e.jpg";